import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
// import { useAuth } from "react-oidc-context";
import Button from "components/Button";
import { getLocaleString } from "utils/localization/locale";
import { SSO_SESSION_RESET } from "reducers/ssoSessionExpired";

export default function SsoSessionExpiredModal() {
  const dispatch = useDispatch();
  const { isExpired } = useSelector((state) => state.ssoSessionExpired);

  if (!isExpired) {
    return null;
  }

  const handleSignInAgain = () => {
    // Read home_url before clearing storage
    const homeUrl = localStorage.getItem("home_link") || window.location.origin;

    // Full cleanup — same as non-Ping logout path
    sessionStorage.clear();
    localStorage.clear();

    dispatch({ type: SSO_SESSION_RESET });

    // Redirect to home_url instead of /login
    setTimeout(() => {
      window.location.replace(homeUrl);
    }, 100);
  };

  return (
    <Modal show centered backdrop="static" keyboard={false}>
      <Modal.Body>
        <h5 className="mb-3">
          {getLocaleString("auth.session_expired_title", "Session Expired")}
        </h5>
        {getLocaleString(
          "auth.session_expired_message",
          "Please sign in again to continue."
        )}
        <div className="d-flex justify-content-end mt-3">
          <Button onClick={handleSignInAgain} size="small">
            {getLocaleString("auth.sign_in_again", "Sign in again")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
